/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
//fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

( function () {
	( function ( $ ) {

        $('body').find('select[name="type-investor"]').on('change', function(){
            const investorSelect = $('body').find('select[name="type-investor"]');

            if(investorSelect.length > 0){
                if($(this).val() === 'Entrepreneur – looking for funding'){
                    const autoCompleteLabel = 'Find and add your address here';
                    $('input.autocomplete-fields-emerald').attr('placeholder', autoCompleteLabel);

                    $('.full-field:first').before('<p style="margin: 1.5rem 0 0 0;"><label style="visibility: visible !important;">Address details:</label><br></p>');

                    const firstAddressLabel = 'Address (Street and Number)';
                    const stateLabel = 'State';
                    const countryLabel = 'Country';
                    const postCodeLabel = 'Postcode';

                    $('.full-field, .slim-field-left, .slim-field-right').each(function() {
                        let labelContent = $(this).find('label').text();

                        if(labelContent === 'Apartment, unit, suite, or floor #'){
                            labelContent = firstAddressLabel;
                        } else if (labelContent === 'State/Province') {
                            labelContent = stateLabel;
                        } else if (labelContent === 'Country/Region') {
                            labelContent = countryLabel;
                        } else if (labelContent === 'Postal code') {
                            labelContent = postCodeLabel;
                        }

                        $(this).find('input').attr('placeholder', labelContent);
                    });
                }
            }
        });

        const showContactDetails = function(data) {
            $('#team-phone-number').attr('href', 'tel:'+data.phone_number).text(data.phone_number);
            $('#team-email').attr('href', 'mailto:'+data.email).text(data.email);
        };

        window.verifyResponseRecaptcha = function(token){
            $.ajax({
                type: 'POST',
                url: emerald_ajax_params.ajaxurl,
                data: {
                    action: 'emerald_resolve_recaptcha',
                    id: $('button#resolve-contact').data('post-id'),
                    token: token
                },
                success: function(response) {
                    const data = JSON.parse(response);
                    if(data.result) {
                        showContactDetails(data);
                    }
                }
            });
        };

        window.onloadCallbackCaptcha = function (){
            $('button#resolve-contact').on('click', function(event) {
                event.preventDefault();
                $(this).hide();
                grecaptcha.render(document.getElementById('g-recaptcha-element'), {
                    'sitekey' : '6LcctmckAAAAAASgt0800jG-isp4VfaRBBe38FLn',
                    'callback' : verifyResponseRecaptcha
                });
            });
        };

        $.fn.resizeselect = function(settings) {
        return this.each(function(){
            var $this = $(this), numberOfOptions = $(this).children('option').length;

            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');

            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.find(":selected") ? $this.find(":selected").text() : $this.children('option').eq(0).text());

            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (var i = 0; i < numberOfOptions; i++) {
                if(i!=0){
                    $('<li />', {
                        text: $this.children('option').eq(i).text(),
                        rel: $this.children('option').eq(i).val(),
                        class: $this.children('option').eq(i).attr('selected') ? 'active' : '',
                    }).appendTo($list);
                }
            }

            var $listItems = $list.children('li');

            $styledSelect.click(function(e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function(){
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });

            $listItems.click(function(e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $list.hide();
                $this.trigger('change');
            });

            $(document).click(function() {
                $styledSelect.removeClass('active');
                $list.hide();
            });
        });
    }

  } )( jQuery );
} )();
